import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Layout from '../components/Layout';
import {api, getCookie} from '../api';

export default function Dashboard() {
  const [courses, setCourses] = useState([]);
  const [clockStatus, setClockStatus] = useState(null);
  const [announcements, setAnnouncements] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const displayName = getCookie('displayName') ? decodeURIComponent(getCookie('displayName')) : 'there';

  useEffect(() => {
    api('/lms/my-courses').then(r => r.ok ? r.json() : []).then(setCourses).catch(() => {});
    api('/timesheets/clock/active').then(r => r.ok ? r.json() : null).then(setClockStatus).catch(() => {});
    api('/hcm/announcements/published').then(r => r.ok ? r.json() : []).then(setAnnouncements).catch(() => {});
    api('/hcm/holidays').then(r => r.ok ? r.json() : []).then(setHolidays).catch(() => {});
  }, []);

  const inProgress = courses.filter(c => !c.completedAt);
  const completed = courses.filter(c => c.completedAt);

  return (
    <Layout>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Welcome, {displayName}</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-1">Clock Status</h3>
          {clockStatus?.clockedIn ? (
            <p className="text-green-600 font-medium">Clocked in since {new Date(clockStatus.startAt).toLocaleTimeString()}</p>
          ) : (
            <p className="text-gray-500">Not clocked in</p>
          )}
          <Link to="/timesheets" className="text-indigo-600 hover:text-indigo-800 text-sm mt-2 inline-block">View Timesheets →</Link>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-1">Training</h3>
          <p className="text-gray-600">{inProgress.length} in progress · {completed.length} completed</p>
          <Link to="/courses" className="text-indigo-600 hover:text-indigo-800 text-sm mt-2 inline-block">View Courses →</Link>
        </div>
      </div>

      {announcements.length > 0 && (
        <div className="bg-white rounded-lg shadow p-6 mb-8">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Announcements</h3>
          <div className="space-y-3">
            {announcements.slice(0, 5).map(a => (
              <div key={a.id} className="border-l-4 border-indigo-500 pl-4 py-1">
                <p className="font-medium text-gray-900">{a.title}</p>
                {a.body && <p className="text-sm text-gray-600 mt-1">{a.body}</p>}
                <p className="text-xs text-gray-400 mt-1">{new Date(a.createdAt).toLocaleDateString()}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      {holidays.length > 0 && (
        <div className="bg-white rounded-lg shadow p-6 mb-8">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Upcoming Holidays</h3>
          <div className="space-y-2">
            {holidays.filter(h => h.date >= new Date().toISOString().slice(0, 10)).slice(0, 5).map(h => (
              <div key={h.id} className="flex items-center justify-between py-2">
                <span className="font-medium text-gray-900">{h.name}</span>
                <span className="text-sm text-gray-500">{new Date(h.date + 'T00:00:00').toLocaleDateString(undefined, {weekday: 'short', month: 'short', day: 'numeric'})}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {inProgress.length > 0 && (
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Continue Training</h3>
          <div className="space-y-3">
            {inProgress.slice(0, 3).map(c => {
              const pct = c.totalPages ? Math.round(c.completedPages / c.totalPages * 100) : 0;
              return (
                <Link key={c.id} to={`/courses/${c.id}`} className="block p-4 border rounded-lg hover:bg-gray-50">
                  <div className="flex justify-between items-center mb-1">
                    <span className="font-medium text-gray-900">{c.title}</span>
                    <span className="text-sm text-gray-500">{pct}%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div className="bg-indigo-600 h-2 rounded-full" style={{width: `${pct}%`}} />
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </Layout>
  );
}
